var map = {
	"./c++.svg": 820,
	"./codeceptjs.svg": 59,
	"./css.svg": 192,
	"./framer.svg": 381,
	"./git.png": 710,
	"./github.svg": 866,
	"./graphql.svg": 323,
	"./html.svg": 218,
	"./js.svg": 905,
	"./mongodb.svg": 794,
	"./nodejs.svg": 365,
	"./python.svg": 946,
	"./react.svg": 978,
	"./sql.svg": 729,
	"./tailwind.svg": 977,
	"./ts.png": 721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;